import scoopSpinnerAsset from '../../../assets/common/Scoop_Loader.gif'

export const ScoopSpinner = ({ size = 36, style = {}, ...props }) => {
    const sizeStyle = typeof size === 'number' ? `${size}px` : size

    return (
        <img
            style={{ width: sizeStyle, ...style }}
            src={scoopSpinnerAsset}
            alt="Scoop loader"
            {...props}
        />
    )
}
